@if (isPermissionLoading) {
<div class="contract-search-loading" aria-live="polite" aria-busy="true">
  <div class="contract-search-loading-card">
    <i class="pi pi-spin pi-spinner contract-search-loading-icon"></i>
    <div class="contract-search-loading-title">Carregando permissões</div>
    <div class="contract-search-loading-text">Aguarde enquanto a autenticação é concluída.</div>
  </div>
</div>
}

@if (!isPermissionLoading && isPermission === false) {
<div class="container permission-page">
  <div class="permission-empty-state">
    <h1 class="permission-empty-state-title" i18n="@@404PageNotFound">{{ 'TRANSLATE.PERMISSIONLESS.USER' | translate }}
    </h1>
    <p class="permission-empty-state-description" i18n="@@couldNotFindThePage">{{
      'TRANSLATE.YOU.ARE.ALLOWED.TO.ACCESS.SCREEN' | translate }}</p>
    <i class="far fa-sad-tear permission-empty-state-icon" aria-hidden="true"></i>
    <a [routerLink]="['/']" class="permission-empty-state-button" i18n="@@goToHomepage">
      {{ 'TRANSLATE.HOME.PAGE' | translate }}
    </a>
  </div>
</div>
}

@if (!isPermissionLoading && isPermission === true) {
<div class="container">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner loading" [style.display]="blockedUi ? 'block' : 'none'"></i>
  </div>
  }
  <div class="grid">
    <div class="col-12">
      <span class="title">{{'TRANSLATE.MANAGE.CONTRACTS' | translate}}</span>
    </div>
    <div class="search-filters-wrapper">
      <p-accordion>
        <p-accordionTab header="Filtros" [selected]="true">
          <div class="ui-fluid filters-grid">
            <!-- CRITICAL FILTERS - REQUIRED FIRST -->
            <div class="filter-item">
              <label class="filtro" for="countrySearch"><strong>{{ 'TRANSLATE.TWO.POINTS.COUNTRY' | translate
                  }}</strong></label><br />
              <p-multiSelect #countrySearchMulti id="countrySearch" [(ngModel)]="filterContractSearch.countries"
                placeholder="{{ 'TRANSLATE.SELECT' | translate }}" [options]="countriesList"
                (onChange)="countryChange($event); scheduleCountryPanelClose(countrySearchMulti)"
                (onPanelHide)="cancelCountryPanelClose()" [style]="{'minWidth':'100%'}" aria-required="true"
                [resetFilterOnHide]="true" appendTo="body">
              </p-multiSelect>
              @if (filterContractSearch.countries.length === 0) {
              <small class="field-hint">
                {{ 'TRANSLATE.SELECT.COUNTRY.FIRST' | translate }}
              </small>
              }
            </div>
            <div class="filter-item">
              <label class="filtro" for="productIdSearch">{{ 'TRANSLATE.TWO.POINTS.PRODUCT.ID' | translate
                }}</label><br />
              <p-dropdown id="productIdSearch" [options]="productActiveCountries"
                placeholder="{{ 'TRANSLATE.SELECT' | translate }}" [(ngModel)]="productActive" optionLabel="code"
                [style]="{'minWidth':'100%'}" [disabled]="!hasSelectedCountries">
                <ng-template pTemplate="item" let-item>
                  {{item?.code === 'Selecione' ? ('TRANSLATE.SELECT' | translate) : item?.code}}
                </ng-template>
                <ng-template pTemplate="selectedItem" let-item>
                  {{item?.code === 'Selecione' ? ('TRANSLATE.SELECT' | translate) : item?.code}}
                </ng-template>
              </p-dropdown>
            </div>
            <!-- SECONDARY FILTERS -->
            <div class="filter-item">
              <label class="filtro" for="saleTypeSearch">{{'TRANSLATE.TWO.POINTS.SALE.TYPE' | translate
                }}</label><br />
              <p-dropdown id="saleTypeSearch" [options]="salesTypeFords" [(ngModel)]="salesTypeFord"
                placeholder="{{ 'TRANSLATE.SELECT' | translate }}" optionLabel="description"
                [style]="{'minWidth':'100%'}" [disabled]="!hasSelectedCountries">
                <ng-template pTemplate="item" let-item>
                  {{item?.description | translate}}
                </ng-template>
                <ng-template pTemplate="selectedItem" let-item>
                  {{item?.description | translate}}
                </ng-template>
              </p-dropdown>
            </div>
            <div class="filter-item">
              <label class="filtro" for="contractStatusSearch">{{ 'TRANSLATE.TWO.POINTS.STATUS' |
                translate }}</label><br />
              <p-dropdown id="contractStatusSearch" [(ngModel)]="filterContractSearch.contractStatus"
                [options]="statusFilter" [style]="{'minWidth':'100%'}"
                placeholder="{{ 'TRANSLATE.SELECT' | translate }}" [disabled]="!hasSelectedCountries">
                <ng-template pTemplate="item" let-item>
                  {{item?.label | translate}}
                </ng-template>
                <ng-template pTemplate="selectedItem" let-item>
                  {{item?.label | translate}}
                </ng-template>
              </p-dropdown>
            </div>
            <div class="filter-item">
              <label class="filtro" for="globalContractSearch">{{ 'TRANSLATE.TWO.POINTS.GLOBAL.CONTRACT' |
                translate }}</label><br />
              <p-dropdown id="globalContractSearch" [(ngModel)]="filterContractSearch.globalContract"
                placeholder="{{ 'TRANSLATE.SELECT' | translate }}" [options]="globalContractFilter"
                [style]="{'minWidth':'100%'}" [disabled]="!hasSelectedCountries">
                <ng-template pTemplate="item" let-item>
                  {{item?.label | translate}}
                </ng-template>
                <ng-template pTemplate="selectedItem" let-item>
                  {{item?.label | translate}}
                </ng-template>
              </p-dropdown>
            </div>
            <!-- DATE FILTERS -->
            <div class="filter-item">
              <label class="filtro" for="dateStartSearch">{{'TRANSLATE.TWO.POINTS.MINIMUM.SALE.DATE' |
                translate}}</label><br />
              <p-datepicker inputId="dateStartSearch" [readonlyInput]="true"
                [(ngModel)]="filterContractSearch.contractDateStart"
                placeholder="{{ 'TRANSLATE.START.SALE.DATE' | translate}}" dateFormat="dd/mm/yy" appendTo="body"
                [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                [disabled]="!hasSelectedCountries"></p-datepicker>
            </div>
            <div class="filter-item">
              <label class="filtro" for="dateEndSearch">
                {{ 'TRANSLATE.TWO.POINTS.MAXIMUM.SALE.DATE' | translate }}
              </label><br />
              <p-datepicker inputId="dateEndSearch" [readonlyInput]="true"
                [(ngModel)]="filterContractSearch.contractDateEnd"
                placeholder="{{ 'TRANSLATE.END.SALE.DATE' | translate }}" dateFormat="dd/mm/yy" appendTo="body"
                [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                [disabled]="!hasSelectedCountries"></p-datepicker>
            </div>
            <div class="filter-item">
              <label class="filtro" for="validityDateStartSearch">
                {{ 'TRANSLATE.TWO.POINTS.MINIMUM.VALIDITY.DATE' | translate }}
              </label><br />
              <p-datepicker inputId="validityDateStartSearch" [readonlyInput]="true"
                [(ngModel)]="filterContractSearch.validityDateStart"
                placeholder="{{'TRANSLATE.START.VALIDITY.DATE' | translate }}" dateFormat="dd/mm/yy" appendTo="body"
                [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [disabled]="!hasSelectedCountries">
              </p-datepicker>
            </div>
            <div class="filter-item">
              <label class="filtro" for="validityDateEndSearch">{{
                'TRANSLATE.TWO.POINTS.MAXIMUM.VALIDITY.DATE' | translate
                }}</label><br />
              <p-datepicker inputId="validityDateEndSearch" [readonlyInput]="true"
                [(ngModel)]="filterContractSearch.validityDateEnd"
                placeholder="{{ 'TRANSLATE.END.VALIDITY.DATE' | translate }}" dateFormat="dd/mm/yy" appendTo="body"
                [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [disabled]="!hasSelectedCountries">
              </p-datepicker>
            </div>
            <!-- TEXT FILTERS -->
            <div class="filter-item">
              <label class="filtro" for="cpfCnpjSearch">{{ getSearchDocumentLabel() }}</label><br />
              <input pInputText id="cpfCnpjSearch" [(ngModel)]="filterContractSearch.document" type="text"
                [maxlength]="getSearchDocumentInputMaxLength()" (input)="onDocumentSearchInput($event)"
                [placeholder]="getSearchDocumentPlaceholder()" style="width: 100%" [disabled]="!hasSelectedCountries" />
              @if (hasTriedFilterSubmit && isSearchDocumentInvalid()) {
              <p-message class="client-data-message" severity="error"
                text="{{ getSearchDocumentErrorKey() | translate }}">
              </p-message>
              }
            </div>
            <div class="filter-item">
              <label class="filtro" for="vinSearch">{{ 'TRANSLATE.TWO.POINTS.VIN' | translate
                }}</label><br />
              <input pInputText id="vinSearch" [(ngModel)]="filterContractSearch.vin" type="text" maxlength="17"
                (input)="onVinSearchInput($event)" placeholder="VIN" style="width: 100%"
                [disabled]="!hasSelectedCountries" />
              @if (hasTriedFilterSubmit && isSearchVinInvalid()) {
              <p-message class="client-data-message" severity="error"
                text="{{ 'TRANSLATE.ENTER.CHASSIS.CORRECTLY' | translate }}">
              </p-message>
              }
            </div>
            <div class="filter-item">
              <label class="filtro" for="contractOriginalNumberSearch">{{
                'TRANSLATE.TWO.POINTS.ORIGINAL.CONTRACT.NUMBER' | translate
                }}</label><br />
              <input pInputText id="contractOriginalNumberSearch"
                [(ngModel)]="filterContractSearch.contractOriginalNumber" type="text" maxlength="10"
                (input)="onContractOriginalNumberInput($event)" placeholder="Número Contrato" style="width: 100%"
                [disabled]="!hasSelectedCountries" />
              @if (hasTriedFilterSubmit && isSearchContractOriginalNumberInvalid()) {
              <p-message class="client-data-message" severity="error"
                text="{{ 'TRANSLATE.SEARCH.ORIGINAL.CONTRACT.NUMBER.INVALID' | translate }}">
              </p-message>
              }
            </div>
            <div class="filter-item">
              <label class="filtro" for="dealerSearch">{{ 'TRANSLATE.TWO.POINTS.DEALER' | translate
                }}</label><br />
              <input pInputText id="dealerSearch" [(ngModel)]="filterContractSearch.dealer" type="text" maxlength="5"
                (input)="onDealerSearchInput($event)" placeholder="Dealer" style="width: 100%"
                [disabled]="!hasSelectedCountries" />
              @if (hasTriedFilterSubmit && isSearchDealerInvalid()) {
              <p-message class="client-data-message" severity="error"
                text="{{ 'TRANSLATE.SEARCH.DEALER.INVALID' | translate }}">
              </p-message>
              }
            </div>
          </div>
          <div class="filter-actions-row">
            <button pButton icon="pi pi-trash" type="button" (click)="buttonClean()" [disabled]="isSubmitted"
              class="btn-pattern btn-clear-filters app-clean-button">
              {{ 'TRANSLATE.CLEAN' | translate }}
            </button>
            <button pButton [disabled]="isSubmitted || !hasSelectedCountries" [attr.aria-busy]="isSubmitted"
              [icon]="isSubmitted ? 'pi pi-spin pi-spinner' : 'pi pi-search'" type="button" (click)="filterValidation()"
              class="btn-pattern btn-search-filters app-filter-button">
              {{ (isSubmitted ? 'TRANSLATE.BNT.FILTERING' : 'TRANSLATE.BNT.FILTER') | translate }}
            </button>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
    @if (filterContractSearchResultTotalRecord.filterContractSearchResultSimplifiedDtos &&
    filterContractSearchResultTotalRecord.filterContractSearchResultSimplifiedDtos.length > 0) {
    <div class="col-12 export-actions-row" style="text-align: right;">
      <button type="button" [disabled]="isSubmittedExcel" [attr.aria-busy]="isSubmittedExcel" (click)="exportExcel()"
        class="excel-export-button">
        <i [ngClass]="isSubmittedExcel ? 'pi pi-spin pi-spinner' : 'pi pi-file-excel'" aria-hidden="true"></i>
        <span class="excel-export-button-label">{{ (isSubmittedExcel ? 'TRANSLATE.EXPORTING.EXCEL' :
          'TRANSLATE.EXPORT.EXCEL') | translate }}</span>
      </button>
    </div>
    }
    <div class="col-12" #pnl>
      <p-table #tabela id="excel-table"
        [value]="filterContractSearchResultTotalRecord.filterContractSearchResultSimplifiedDtos" [lazy]="true"
        (onLazyLoad)="loadData($event)" [totalRecords]="filterContractSearchResultTotalRecord.totalRecord"
        [paginator]="true" [rows]="filterContractSearch.rowsPage"
        styleClass="contract-results-table app-table app-table--wide app-table--condensed app-table--sticky-action">
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="10">
              {{ 'TRANSLATE.NO.CONTRACTS.FOUND' | translate }}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 130px !important;">{{ 'TRANSLATE.CONTRACT' | translate }} </th>
            <th style="width: 170px !important;">{{ 'TRANSLATE.ORIGINAL.CONTRACT' | translate }}</th>
            <th style="width: 190px !important;">{{ 'TRANSLATE.VIN' | translate }}</th>
            <th style="width: 130px !important;">{{ 'TRANSLATE.STATUS' | translate }}</th>
            <th class="col-plan-name">{{ 'TRANSLATE.PLAN.NAME' | translate }}</th>
            <th class="col-limits">{{ 'TRANSLATE.LIMITS' | translate }}</th>
            <th style="width: 120px !important;">{{"TRANSLATE.SALE.DATE" | translate }}</th>
            <th style="width: 120px !important;">{{"TRANSLATE.START.DATE" | translate }}</th>
            <th style="width: 120px !important;">{{"TRANSLATE.END.DATE" | translate }}</th>
            <th style="width: 80px !important;">{{ 'TRANSLATE.ACTIONS' | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData>
          <tr style="text-align: center;">
            <td style="width: 130px !important;">
              {{ rowData.contractNumber }}
            </td>
            <td style="width: 170px !important;">
              {{ rowData.contractOriginalNumber }}
            </td>
            <td style="width: 190px !important;">
              {{ rowData.vin }}
            </td>
            <td style="width: 130px !important;">
              {{ statusName(rowData.status) | translate }}
            </td>
            <td class="col-plan-name" [title]="rowData.planName">
              <span class="app-cell-clamp-2">{{ rowData.planName }}</span>
            </td>
            <td class="col-limits" [title]="rowData.limite">
              <span class="app-cell-clamp-2">{{ rowData.limite }}</span>
            </td>
            <td style="width: 120px !important;">
              {{ rowData.vinSaleDate | date:'dd/MM/yyyy' }}
            </td>
            <td style="width: 120px !important;">
              {{ rowData.dateStart | date:'dd/MM/yyyy' }}
            </td>
            <td style="width: 120px !important;">
              {{ rowData.coverageEndDate | date:'dd/MM/yyyy' }}
            </td>
            <td style="width: 80px !important;">
              <div class="item-position">
                <button mat-icon-button [matMenuTriggerFor]="menu" class="btn-action-menu"
                  (click)="retrievingContractId(rowData.contractNumber, rowData.country, rowData.productCode)">
                  <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #menu="matMenu" panelClass="table-action-menu">
                  @if (contractStatus.includes(rowData.status) && systemCountry === 'BRA' && rowData.country === 'BRA' )
                  {
                  <button mat-menu-item
                    (click)="showDialog(rowData.contractKey, rowData.productKey, rowData.coverageCategoryKey)">
                    {{ 'TRANSLATE.CANCEL' | translate }}
                  </button>
                  }
                  @if (rowData.status === contractStatusCode && systemCountry === 'BRA' && rowData.country === 'BRA' ) {
                  <button mat-menu-item
                    (click)="openModalUndoCancel(rowData.contractKey, rowData.vin, rowData.productKey)"
                    class="custom-class-btn">
                    {{ 'TRANSLATE.UNTO.THE.CANCELLATION.REQUEST' | translate }}
                  </button>
                  }
                  <button mat-menu-item (click)="buttonEdit(rowData)">
                    {{ 'TRANSLATE.EDIT' | translate }}
                  </button>
                  @if (rowData.country !== 'BRA' && rowData.country !== 'VEN' ) {
                  <button mat-menu-item (click)="handleGeneratePdf()">
                    {{ 'TRANSLATE.GENERATE.PDF' | translate }}
                  </button>
                  }
                  @if (rowData.country === 'BRA' && rowData.productCode !== 'PREB' ) {
                  <button mat-menu-item (click)="handleGeneratePdf()">
                    {{ 'TRANSLATE.GENERATE.PDF' | translate }}
                  </button>
                  }
                  @if (rowData.country === 'BRA' && rowData.productCode === 'PREB' ) {
                  <button mat-menu-item (click)="handleGeneratePdf()">
                    {{ 'TRANSLATE.GENERATE.PDF' | translate }}
                  </button>
                  }
                </mat-menu>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<!-- Cancellation Modal -->
<div>
  <p-dialog styleClass="icon-close cancel-request-dialog" header="{{ 'TRANSLATE.REQUEST.CANCELLATION' | translate }}"
    [(visible)]="display" [modal]="true" [style]="{ width: '30rem' }" (onHide)="clearEditableCancellationFields()">

    <div class="modal-body">

      <div class="modal-itens">
        <h4 class="modal-itens-title">{{ 'TRANSLATE.CONTRACT.OVERVIEW' | translate }}</h4>
        <div class="modal-bank-info">
          <div class="modal-element">
            <span class="modal-element-label">{{ 'TRANSLATE.ID.PRODUCT.NAME' | translate }}</span>
            <p class="modal-element-p">{{idProductNameModal}}</p>
          </div>

          <div class="modal-element">
            <span class="modal-element-label">{{ 'TRANSLATE.CHASSIS' | translate }}</span>
            <p class="modal-element-p">{{chassiModal}}</p>
          </div>

          <div class="modal-element">
            <span class="modal-element-label">{{ 'TRANSLATE.NAME' | translate }}</span>
            <p class="modal-element-p">{{customerNameModal}}</p>
          </div>

        </div>
      </div>

      <div class="modal-itens">
        <h4 class="modal-itens-title">{{ 'TRANSLATE.CANCELLATION.INFORMATION' | translate }}</h4>

        <div class="modal-inform">

          <div class="modal-element">
            <label class="modal-element-title" for="cancellationDateModalSearch">
              {{ 'TRANSLATE.CANCELLATION.REQUEST.DATE' | translate }}
            </label>
            <input id="cancellationDateModalSearch" [(ngModel)]="cancellationDateModal" class="modal-element-input"
              (click)="picker.open()" matInput [matDatepicker]="picker" pInputText>

            @if (hasTriedCancellationSubmit && cancellationDateModal === null) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.ENTER.REQUEST.DATE' | translate }}">
            </p-message>
            }
            <mat-datepicker #picker></mat-datepicker>
          </div>

          <div class="modal-element select-top">
            <label class="modal-element-label" for="reasonDropdownSearch">
              {{ 'TRANSLATE.REASON' | translate }}
            </label>
            <p-dropdown id="reasonDropdownSearch" (onChange)="reasonChange($event)" [(ngModel)]="selectedReason"
              [options]="cancellationReason" class="" [style]="{'minWidth':'100%'}">
              <ng-template pTemplate="item" let-item>
                {{item?.label | translate}}
              </ng-template>
              <ng-template pTemplate="selectedItem" let-item>
                @if (item?.label) {
                <span>{{ item.label | translate }}</span>
                } @else {
                {{ 'TRANSLATE.SELECT' | translate }}
                }
              </ng-template>
            </p-dropdown>
            @if (hasTriedCancellationSubmit && selectedReason === null) {
            <p-message class="client-data-message" severity="error" text="{{ 'TRANSLATE.TELL.US.WHY' | translate }}">
            </p-message>
            }
          </div>

        </div>

        <div class="modal-inform-two">

          <div class="modal-element">
            <label class="modal-element-label" for="carMileageSearch">
              {{ 'TRANSLATE.MILEAGE' | translate }}
            </label>
            <input class="modal-element-input" id="carMileageSearch" type="text" [(ngModel)]="carMileage" minlength="1"
              [maxlength]="cancellationMileageMaxLength" placeholder="{{ 'TRANSLATE.MILEAGE' | translate }}"
              (input)="formatOdometerNumber($event)" pInputText>

            @if (hasTriedCancellationSubmit && (zeroMileage === null || zeroMileage <= 0)) {
            <p-message class="client-data-message" severity="error"
              text="{{ getCancellationMileageErrorKey() | translate }}">
            </p-message>
            }
          </div>

          <div class="modal-element">

            <label class="modal-element-label" for="dealerEmailSearch">{{ 'TRANSLATE.DEALER.EMAIL' |
              translate }}</label>
            <input id="dealerEmailSearch" minlength="1" [maxlength]="cancellationEmailMaxLength"
              [(ngModel)]="dealerEmail" type="text" placeholder="{{ 'TRANSLATE.ENTER.EMAIL' | translate }}"
              (blur)="dealerEmail = dealerEmail ? dealerEmail.toLowerCase() : null" pInputText>
            <span class="field-limit-hint">{{ 'TRANSLATE.CLIENT.DATA.CHARACTER.COUNTER' | translate:{ current:
              getValueLength(dealerEmail), max: cancellationEmailMaxLength } }}</span>

            @if (hasTriedCancellationSubmit && ((dealerEmail === null || dealerEmail === '') ||
            isEmailFormatInvalid(dealerEmail))) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFO.EMAIL.CORRECT.DEALER' | translate }}">
            </p-message>
            }
          </div>

        </div>

        <div class="modal-inform-two">

          <div class="modal-element">

            <label class="modal-element-label" for="sellerEmailSearch">
              {{ 'TRANSLATE.SELLER.EMAIL' | translate }}
            </label>
            <input id="sellerEmailSearch" minlength="1" [maxlength]="cancellationEmailMaxLength"
              [(ngModel)]="sellerEmail" type="text" placeholder="{{ 'TRANSLATE.ENTER.EMAIL' | translate }}"
              (blur)="sellerEmail = sellerEmail ? sellerEmail.toLowerCase() : null" pInputText>
            <span class="field-limit-hint">{{ 'TRANSLATE.CLIENT.DATA.CHARACTER.COUNTER' | translate:{ current:
              getValueLength(sellerEmail), max: cancellationEmailMaxLength } }}</span>

            @if (hasTriedCancellationSubmit && ((sellerEmail === null || sellerEmail === '') ||
            isEmailFormatInvalid(sellerEmail))) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFO.EMAIL.CORRECT.SELLER' | translate }}">
            </p-message>
            }
          </div>

          <div class="modal-element">
            <label class="modal-element-label" for="observationsSearch">{{ 'TRANSLATE.OBSERVATIONS' |
              translate }}</label>
            <textarea class="modal-element-input" id="observationsSearch" type="text" [(ngModel)]="observations"
              minlength="2" [maxlength]="cancellationObservationsMaxLength" pInputTextarea></textarea>
            <span class="field-limit-hint">{{ 'TRANSLATE.CLIENT.DATA.CHARACTER.COUNTER' | translate:{ current:
              getValueLength(observations), max: cancellationObservationsMaxLength } }}</span>

            @if (hasTriedCancellationSubmit && (observations === null || observations === '')) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.INFORME.OBSERVATIONS' | translate }}">
            </p-message>
            }
          </div>

        </div>
      </div>

    </div>

    <div class="modal-footer cancel-modal-actions">
      <button class="action-button-return" id="btnReturn" severity="secondary" type="button"
        [disabled]="isSubmittingCancellation" (click)="clearModalCancel()">
        <i class="pi pi-arrow-left cancel-return-icon" aria-hidden="true"></i>
        <span class="action-button-return-label">{{ 'TRANSLATE.RETURN' | translate }}</span>
      </button>

      <button class="action-button btn-cancel space-btn cancel-submit-button" id="btnSave" severity="secondary"
        type="button" [disabled]="isSubmittingCancellation || blockedUi" (click)="cancelRequestButton()">
        <i [ngClass]="isSubmittingCancellation ? 'pi pi-spin pi-spinner cancel-submit-icon' : 'pi pi-send cancel-submit-icon'"
          aria-hidden="true"></i>
        <span class="action-button-label">{{ (isSubmittingCancellation ? 'TRANSLATE.REQUESTING.CANCELLATION' :
          'TRANSLATE.REQUEST.CANCELLATION') | translate }}</span>
      </button>
    </div>

  </p-dialog>

</div>

<!-- Undo Cancellation Modal -->
<div>
  <p-dialog styleClass="icon-close undo-cancel-dialog"
    header="{{ 'TRANSLATE.UNTO.THE.CANCELLATION.REQUEST' | translate }}" [(visible)]="displayUndoCancel" [modal]="true"
    [style]="{ width: '30rem' }">

    <div class="modal-body space-first">

      <div class="modal-itens">
        <div class="modal-bank-info">
          <div class="modal-element">
            <p class="modal-element-p">
              {{ 'TRANSLATE.YOU.SURE.YOU.WANT.TO.UNDO.THE.CANCELLATION.REQUEST' | translate }}
              {{contractIDUndoCancellation}}?
            </p>
          </div>
        </div>
      </div>

    </div>

    <div class="modal-footer undo-modal-actions">
      <button class="action-button-return" id="btnReturn" severity="secondary" (click)="clearFieldsUndoCancel()"
        [disabled]="disableReactivateContract">
        <i class="pi pi-arrow-left undo-return-icon" aria-hidden="true"></i>
        <span class="action-button-return-label">{{ 'TRANSLATE.RETURN' | translate }}</span>
      </button>
      <button class="action-button btn-cancel space-btn undo-submit-button" id="btnSave" severity="secondary"
        (click)="undoButtonCancellation()" [disabled]="disableReactivateContract">
        <i [ngClass]="disableReactivateContract ? 'pi pi-spin pi-spinner undo-submit-icon' : 'pi pi-refresh undo-submit-icon'"
          aria-hidden="true"></i>
        <span class="action-button-label disabled-label">
          {{ (disableReactivateContract ? 'TRANSLATE.REACTIVATING.CONTRACT' : 'TRANSLATE.REACTIVE.CONTRACT') | translate
          }}
        </span>
      </button>
    </div>

  </p-dialog>

</div>

<!-- PDF Modal -->
<div>

  <div>
    <p-dialog styleClass="pdf-selection-dialog" header="{{ 'TRANSLATE.CONFIRMATION' | translate }}"
      [(visible)]="displayModalPdf" [modal]="true" [style]="{ width: '30rem' }">

      <div class="modal-body modal-pdf-body">

        <div class="modal-itens modal-pdf-itens">
          <h4 class="modal-itens-title modal-pdf-title">{{ 'TRANSLATE.CONTINUE.PLEASE.SELECT.DESIRED.DOCUMENT' |
            translate }}
          </h4>
          <div class="modal-radio modal-pdf-options">
            @if (hasTermDownloadOption()) {
            <div class="modal-radio-btn modal-pdf-option">
              <p-radioButton name="documentType" [value]="DOCUMENT_TYPE_TERM" [(ngModel)]="documentType"
                inputId="document1" (ngModelChange)="opDocument($event)"></p-radioButton>
              <label for="document1" class="radio-position-label">
                {{ 'TRANSLATE.TERM' | translate }}
              </label>
            </div>
            }
            @if (ticketFileId && ticketFileId > 0) {
            <div class="modal-radio-btn modal-pdf-option">
              <p-radioButton name="documentType" [value]="DOCUMENT_TYPE_TICKET" [(ngModel)]="documentType"
                inputId="document2" (ngModelChange)="opDocument($event)"></p-radioButton>
              <label for="document2" class="radio-position-label">
                {{ 'TRANSLATE.TICKET' | translate }}
              </label>
            </div>
            }
          </div>
          <div>

            @if (showDocumentTypeError) {
            <p-message class="client-data-message" severity="error"
              text="{{ 'TRANSLATE.SELECTED.DOCUMENT.TYPE' | translate }}">
            </p-message>
            }
          </div>
        </div>

      </div>

      <div class="modal-footer modal-pdf-actions">
        <button class="action-button-return" id="btnReturn" severity="secondary" (click)="clearModalPdf()"
          [disabled]="isDownloadingPdf">
          <i class="pi pi-arrow-left modal-pdf-action-icon" aria-hidden="true"></i>
          <span class="action-button-return-label">{{ 'TRANSLATE.RETURN' | translate }}</span>
        </button>
        <button class="action-button btn-pdf" id="btnDownload" severity="secondary" (click)="downloadPdf()"
          [disabled]="isDownloadingPdf || blockedUi">
          <i [ngClass]="isDownloadingPdf ? 'pi pi-spin pi-spinner modal-pdf-action-icon' : 'pi pi-download modal-pdf-action-icon'"
            aria-hidden="true"></i>
          <span class="action-button-label">{{ isDownloadingPdf ? ('TRANSLATE.GENERATING.PDF' | translate) :
            ('TRANSLATE.DOWNLOAD' | translate) }}</span>
        </button>
      </div>

    </p-dialog>
  </div>

</div>
}